import React from 'react';
import { IconProps } from '../types';
const MinecraftPointedDripstone: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="0" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="5" y="0" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="6" y="0" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="7" y="0" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="8" y="0" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="9" y="0" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="10" y="0" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="11" y="0" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="4" y="1" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="5" y="1" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="6" y="1" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="7" y="1" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(160, 141, 113, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(160, 141, 113, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(160, 141, 113, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(160, 141, 113, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(160, 141, 113, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(160, 141, 113, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(115, 84, 80, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(160, 141, 113, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(160, 141, 113, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(131, 99, 86, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(146, 121, 101, 255)" />
</svg>);
export default MinecraftPointedDripstone;